/** Changes Claude Desktop asked for, waiting for the user's decision in Nexus. */
import { create } from 'zustand';
import type { ActionPreview } from '@nexus/ai';

interface Pending {
  id: number;
  preview: ActionPreview;
  resolve: (confirmed: boolean) => void;
}

let nextId = 1;

export const useMcpConfirm = create<{
  queue: Pending[];
  ask: (preview: ActionPreview) => Promise<boolean>;
  answer: (id: number, confirmed: boolean) => void;
}>((set, get) => ({
  queue: [],
  ask: (preview) =>
    new Promise<boolean>((resolve) => {
      set((s) => ({ queue: [...s.queue, { id: nextId++, preview, resolve }] }));
    }),
  answer: (id, confirmed) => {
    const item = get().queue.find((p) => p.id === id);
    item?.resolve(confirmed);
    set((s) => ({ queue: s.queue.filter((p) => p.id !== id) }));
  },
}));
